import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDpLAFOcdcLFADDAUf6DLVDxMkgK1Q4OiI",
  authDomain: "rangga-wiraguna.firebaseapp.com",
  projectId: "rangga-wiraguna",
  storageBucket: "rangga-wiraguna.appspot.com",
  messagingSenderId: "334449812091",
  appId: "1:334449812091:web:afdbf66f9acdca5b6a38de",
};

const firebaseApp = initializeApp(firebaseConfig);
const firebaseDatabase = getFirestore(firebaseApp);

export { firebaseApp, firebaseDatabase };
